<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormAutorizar" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div v-show="MostrarPermitirAutorizacion" class="form-group row">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <label class="" for="">¿Autorizar?</label>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="row">
                                <div v-show="MostrarPermitirAutorizacion" class="col-lg-3">
                                    <div class="form-check">
                                        <input @change="HabilitarMotivo" v-model="objRequisicion.EstatusAutorizado" id="Autorizar" type="radio" class="form-check-input" value="si">
                                        <label class="form-check-label" for="Autorizar">SI</label>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-check">
                                        <input @change="HabilitarMotivo" v-model="objRequisicion.EstatusAutorizado" id="NoAutorizar" type="radio" class="form-check-input" value="no">
                                        <label class="form-check-label" for="NoAutorizar">NO</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="MostrarMotivo" class="form-group row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <label for="">Motivo</label>
                            <textarea :disabled="DesactivarMotivo" class="form-control" id="" cols="30" rows="10" v-model="objRequisicion.Motivo"></textarea>
                            <CValidation v-if="this.errorvalidacion.Motivo" :Mensaje="'*'+errorvalidacion.Motivo[0]"/>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
export default {
    name:'FormAutorizar',
    props:['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            objRequisicion:{
                IdRequisicion:0,
                Estatus:'',
                EstatusAutorizado:'',
                Motivo:''
            },
            errorvalidacion:[],
            Emit: this.poBtnSave.EmitSeccion,
            MostrarMotivo:false,
            MostrarPermitirAutorizacion:true,
            DesactivarMotivo:false
        }
    },
    methods: {
        async Guardar(){
            this.poBtnSave.DisableBtn = true;
            this.objRequisicion.Estatus=this.objRequisicion.EstatusAutorizado=='si' ? 'AUTORIZADA' : 'RECHAZADA';
            let formData=new FormData();
            formData.set('EstatusAutorizado',this.objRequisicion.EstatusAutorizado);
            formData.set('Estatus',this.objRequisicion.Estatus);
            formData.set('Motivo',this.objRequisicion.Motivo);
            await this.$http.post('requisicionesAutorizar/'+this.objRequisicion.IdRequisicion,formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.ConfigLoad.ShowLoader=true;
            this.$http.get("requisiciones/"+this.objRequisicion.IdRequisicion
            ).then((res)=>{
                this.objRequisicion.Motivo=res.data.data.Motivo;
                this.objRequisicion.EstatusAutorizado=res.data.data.EstatusAutorizado;
                if (this.objRequisicion.EstatusAutorizado=='no') {
                    this.MostrarMotivo=true;
                    this.MostrarPermitirAutorizacion=false;
                    this.DesactivarMotivo=true;
                }
                this.ConfigLoad.ShowLoader=false;
            });
        },
        Limpiar(){
            this.objRequisicion={
                IdRequisicion:0,
                Estatus:'',
                EstatusAutorizado:'',
                Motivo:''
            }
            this.errorvalidacion=[];
        },
        HabilitarMotivo(){
            this.MostrarMotivo=this.objRequisicion.EstatusAutorizado=='no' ? true : false;
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>{
            this.Limpiar();
            this.objRequisicion.IdRequisicion=Id;
            this.Recuperar();
            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
        })
    },
}
</script>

<style>

</style>